/* Oodles of Paws — scroll choreography. IntersectionObserver only; no scroll listeners. */
(function () {
  var STATES = ['st-sit', 'st-walk', 'st-jump', 'st-roll'];
  function setState(dog, st) { STATES.forEach(function (s) { dog.classList.remove(s); }); void dog.offsetWidth; dog.classList.add(st); }
  function startRoutine(el) {
    if (el.dataset.started) return; el.dataset.started = '1';
    var dog = el.querySelector('.oop-walker__dog'); if (!dog) return;
    var T = 20000; /* must match oop-walk-x */
    setState(dog, 'st-sit');
    setTimeout(function () { setState(dog, 'st-walk'); }, T * 0.15);
    setTimeout(function () { setState(dog, 'st-jump'); }, T * 0.30);
    setTimeout(function () { setState(dog, 'st-walk'); }, T * 0.45);
    setTimeout(function () { setState(dog, 'st-roll'); }, T * 0.60);
    setTimeout(function () { setState(dog, 'st-sit'); }, T * 0.60 + 3900);
  }
  function reveal(el) { el.classList.add('is-in'); if (el.classList.contains('oop-walker')) startRoutine(el); }
  var sel = '.oop-reveal,.oop-trail,.oop-walker,.oop-pawjoin';
  if (!('IntersectionObserver' in window)) { document.querySelectorAll(sel).forEach(reveal); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
  function arm(root) {
    (root || document).querySelectorAll('.oop-reveal:not(.is-in),.oop-trail:not(.is-in),.oop-walker:not(.is-in),.oop-pawjoin:not(.is-in)').forEach(function (el) { io.observe(el); });
  }
  arm();
  document.addEventListener('shopify:section:load', function (ev) { arm(ev.target); });
})();
